import Backbone from 'backbone'
import _ from 'lodash'
import AdminManageRollupTreesPanel from './admin-manage-rollup-trees-panel'
import template from './admin-manage-rollup-trees-dialog.hbs'

const AdminManageRollupTreesDialog = Backbone.View.extend({

	className: 'admin-manage-dataset-trees-dialog',

	initialize: function(options = {}) {
		this.options = options
	},

	render: function() {
		this.$el.empty().append(template())
		this.panel = new AdminManageRollupTreesPanel(this.options)
		this.$('.dialog-body-content').append(this.panel.el)
		this.panel.render()

		this._setupEvents()

		return this
	},

	_setupEvents() {
		// Propagate all change events from the panel
		this.panel.on('change', trees => this.trigger('change', trees))
		this.panel.on('replace', tree => this.trigger('replace', tree))
	},

	remove: function() {
		// #53588 On close we want the tooltip to be displayed
		this.trigger('remove')
		Backbone.View.prototype.remove.apply(this, arguments)
		_.invokeMap([this.panel], 'remove')
	}
})

export default AdminManageRollupTreesDialog

AdminManageRollupTreesDialog.__filename__ = 'admin/datasets/admin-manage-rollup-trees-dialog.js'
